import * as React from 'react';

import './style.scss';
import { StaticImage } from 'gatsby-plugin-image';

const ForumsSection = () => {
  return (
    <section className="l-forums-section">
      <div className="container">
        <h2 className="section-title">
          Forums Continued to Build the Professional Standards Community
        </h2>

        <div className="section-content">
          <p>
            The Councils delivered two online Forums in the reporting period, continuing engagement with occupational associations and delivering encouragement and assistance for the development of associations’ regulatory capacity.
          </p>
          <p>
            The October 2021 Forum was on ‘Continuing professional development in the regulation of professional standards’; the April 2022 Forum was on ‘Responding to risk – insurance and improvement strategies’.
          </p>
        </div>

        <div className="grid">
          <div
            className="card"
            data-sal="slide-up"
            data-sal-duration="1000"
            data-sal-delay="300"
            data-sal-easing="ease"
          >
            <StaticImage layout="fullWidth" src="./assets/forum-1.jpg" alt="Video presentation on Risk Management by Mr John Rogers at the October 2021 Professional Standards Forum." />
          </div>

          <div
            className="card"
            data-sal="slide-up"
            data-sal-duration="1000"
            data-sal-delay="300"
            data-sal-easing="ease"
          >
            <StaticImage layout="fullWidth" src="./assets/forum-2.jpg" alt="Screenshot of video call showing April 2022 Forum participants." />
          </div>
        </div>
      </div>
    </section>
  );
};

export default ForumsSection;
